enum DocumentsOrderBy {
  NAME = 'name',
  DATE = 'date',
}

export default DocumentsOrderBy;
